module.exports = __webpack_public_path__ + "static/media/kehujiaochexinxibiao.eeb98dfd.png";